import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss']
})
export class MaintenancePageComponent implements OnInit {

  currentOrganization: string = 'dk';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}


  ngOnInit() {

    const navigation = this.router.getCurrentNavigation();

    localStorage.clear(); sessionStorage.clear();
    
    if (navigation?.extras?.state?.['currentOrganization']) {
      this.currentOrganization = navigation.extras.state['currentOrganization'];
    } else {
      // Try to get from route state (if navigated with state)
      const state = history.state;
      if (state?.currentOrganization) {
        this.currentOrganization = state.currentOrganization;
      } else {
        // Fallback to sessionStorage
        this.currentOrganization = sessionStorage.getItem('organisation') || 'dk';
      }
    }
    
  }
}
